import type {
  CollaborationNote,
  CreateCollaborationNotePayload,
  UpdateCollaborationNotePayload,
} from "types/collaborationNote";
import SecureRequest from "../utils/securerequest";

/**
 * Fetches collaboration notes for a client-provider pair.
 *
 * @param clientId - The client ID.
 * @param providerId - The provider ID.
 */
export async function getCollaborationNotes(
  clientId: string,
  providerId: string,
): Promise<{ data: CollaborationNote[] }> {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return Request.get(
    `/v2/customers/${clientId}/physicians/${providerId}/collaboration-notes`,
  );
}

/**
 * Creates a new collaboration note for a client-provider pair.
 *
 * @param clientId - The client ID.
 * @param providerId - The provider ID.
 * @param payload - The note body.
 */
export async function createCollaborationNote(
  clientId: string,
  providerId: string,
  payload: CreateCollaborationNotePayload,
): Promise<{ data: CollaborationNote }> {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return Request.post(
    `/v2/customers/${clientId}/physicians/${providerId}/collaboration-notes`,
    payload,
  );
}

/**
 * Updates an existing collaboration note.
 *
 * @param clientId - The client ID.
 * @param providerId - The provider ID.
 * @param noteId - The note ID.
 * @param payload - The updated note body.
 */
export async function updateCollaborationNote(
  clientId: string,
  providerId: string,
  noteId: string,
  payload: UpdateCollaborationNotePayload,
): Promise<{ data: CollaborationNote }> {
  const sr = new SecureRequest();
  const Request = sr.getRequest();
  return Request.put(
    `/v2/customers/${clientId}/physicians/${providerId}/collaboration-notes/${noteId}`,
    payload,
  );
}
